<template>
  <div id="list-review" class="container" >
    <div class="row">
      <div class="form-group col-md-3">
        <label>Tên người đánh giá</label>
        <div class="input-group mb-4">
          <input v-mdel="condition_search.customer_name" class="form-control" placeholder="Name" type="text">
          <div class="input-group-prepend">
            <span class="input-group-text"><i class="fa fa-search"></i></span>
          </div>        
        </div>
      </div>
      <div class="form-group col-md-3">
        <label>Tên Cố vấn</label>
        <div class="input-group mb-4">
          <input v-model="condition_search.counselor_name" class="form-control" placeholder="Email" type="text">
          <div class="input-group-prepend">
            <span class="input-group-text"><i class="fa fa-map-marker"></i> </span>
          </div>        
        </div>
      </div>      
    </div>
    <dir class="row">
      <div class="btn btn-info form-group" @click="search()">Tìm kiếm</div>
    </dir>    
    <div class='table-outer'>
      <table class="table table-light" border="1">
        <thead>
          <tr>
            <th>Tên người đánh giá</th>
            <th>Tên Cố vấn</th>
            <th>Nội dung</th>
            <th>Điểm đánh giá</th>
            <th>Trạng thái</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="review in list_reviews">
            <td>{{review.customer_name}}</td>
            <td>{{review.counselor_name}}</td>
            <td data-toggle="tooltip" data-placement="top" :title='review.comment'>
              <div class="div-question">{{review.comment}}</div>
            </td>
            <td>
              <star-rating v-model="review.rating_score"
                :star-size='25'
                read-only=true
                :show-rating='false'>
              </star-rating>
            </td>
            <td class='label-status-cell'>
              <div class='badge badge-pill label-status'
                :class="{
                  'badge-default': review.public_status=='pending',
                  'badge-info': review.public_status=='public',
                  'badge-danger': review.public_status=='cancel'
                }">
                {{review.public_status}}
              </div>              
            </td>
            <td>
              <div class="button-group">
                <a v-if="review.public_status!='public'" class="btn btn-success form-group" @click="update_status({id: review.id, status:'public'})">Publish</a>
                <a v-else class="btn btn-warning form-group" @click="update_status({id: review.id, status:'cancel'})">UnPublish</a>
              </div>
            </td>
          </tr>               
        </tbody>
      </table>
    </div>
    <base-pagination      
      :pageCount="pagination.total_page"
      :value="current_page"
      @input="pagination.current_page=$event"
    ></base-pagination>    
  </div>  
</template>
<script>
import Multiselect from 'vue-multiselect';
import {mapState, mapActions, mapGetters, mapMutations} from 'vuex';
import StarRating from 'vue-star-rating';
export default{
  components:{
    Multiselect,
    StarRating
  },
  data: function(){
    return{
      show_modal_detail_appointment: false ,
      show_loading_modal: false,
      change_state: true,
      condition_search:{
        status: '',
        customer_name: '',
        counselor_name: '',
      },
      filter_status: ['requesting', 'approvaled', 'meeting', 'completed', 'cancel']
    }    
  },
  created: function(){
    this.$store.dispatch('vuex_admin/get_list_reviews', 1)
  },
  computed: {
    ...mapState('vuex_admin',[
      // 'list_appointments',
    ]),
    ...mapState('vuex_admin',{
      pagination: state => state.pagination_review,
      current_page: state => state.pagination_review.current_page,
      list_reviews: (state) => {
        return state.list_reviews
      }
    })
  },
  watch: {
    current_page(new_value, old_value){
      if (old_value != undefined){
        this.$store.dispatch('vuex_admin/get_list_reviews', new_value)
      }
    },    
  },
  methods: {
    search(){
      alert('Tìm kiếm');
    },
    update_status(data){
      this.show_loading_modal = true
      this.$store.dispatch('vuex_admin/update_review', data)
      this.$store.dispatch('vuex_admin/get_list_reviews', this.current_page)
      this.show_loading_modal = false
    },
  }
};
</script>
<style lang="scss" scoped>
  @import "./list_review"
</style>


// WEBPACK FOOTER //
// src/views/components/Admin/ListReview.vue